import menu from './menu'
import snackbar from './snackbar'
// import settings from './settings'
import api from './api'
import include from '@/store/helpers/include'
import systemLanguage from '@/store/helpers/systemLanguage'
export default {
    menu,
    snackbar,
    include,
    systemLanguage,
}
